import { Fab, FabProps } from '@material-ui/core'
import { Add, GetApp } from '@material-ui/icons'
import CreateIcon from '@material-ui/icons/Create'
import React from 'react'
interface Props extends FabProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  footer?: boolean
  floatTemplate?: boolean
  floatTotalAmt?: boolean
  isCreate?: boolean
  isDownload?: boolean
}
export default function FloatButton(props) {
  const {
    onClick,
    footer,
    floatTemplate,
    floatTotalAmt,
    isCreate,
    isDownload,
    style,
    ...rest
  } = props
  return (
    <Fab
      {...rest}
      aria-label="add"
      style={{
        ...style,
        bottom: floatTotalAmt ? `100px` : floatTemplate ? '60px' : '',
        marginBottom: '0px', // PREVIOUSLY 25px due to Copyright Footer
      }}
      className={`float-btn ${footer ? 'with-footer' : ''}`}
      onClick={onClick}
    >
      {isCreate ? <CreateIcon /> : isDownload ? <GetApp /> : <Add />}
    </Fab>
  )
}
